/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingdeleted1Inputs */

const en_crosspostingdeleted1 = /** @type {(inputs: Crosspostingdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post deleted`)
};

const de_crosspostingdeleted1 = /** @type {(inputs: Crosspostingdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag gelöscht`)
};

/**
* | output |
* | --- |
* | "Post deleted" |
*
* @param {Crosspostingdeleted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingdeleted1 = /** @type {((inputs?: Crosspostingdeleted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingdeleted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingdeleted1(inputs)
	return de_crosspostingdeleted1(inputs)
});
export { crosspostingdeleted1 as "crosspostingDeleted" }